/**
 * @fileoverview GET handler for the "/engagement/user/matcher" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { PostEngagementUserMatcherProps, EngagementUserMatcherResult } from "./types";

export const getEngagementUserMatcher = reactQueryFetcherAdapter(
  "/engagement/user/matcher",
  (signal: AbortSignal, props: PostEngagementUserMatcherProps): Promise<EngagementUserMatcherResult> => {
    return fetch("/engagement/user/matcher", "POST", props);
  }
);
